<template>
  <DashboardTemplate class="discussion-forum">
    <div v-loading="loading">
      <div class="text-left">
        <h4 class="text-font-18 mg-t-less">วิชาที่ {{ subject.index }} {{ subject.name }}</h4>
      </div>
      <DiscussionForumList :discussionForumConst="discussion" :formatAdmin="false"/>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import DiscussionForumList from "@/components/discussionForum/DiscussionForumList";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    DiscussionForumList,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      course: "",
      subject:'',
      discussion: [],
      loading: true,
    };
  },
  mounted() {
    this.fetchSubjectId();
    this.fetchCourseList();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    fetchSubjectId() {
      let obj = {
        subjectId: this.$route.query.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.discussion = res.data.obj.discussion;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubjectId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
